import { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { NakedUl, type UlProps } from '../../naked/naked-ul.component';

const styledListboxListBaseStyle = css`
  flex: 1;
  overflow-y: auto;
  margin: 0;
  &:focus {
    outline: none;
  }

  // this was using styles.smallScrollbar but reused the static css to work with linaria

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.small};
  }
`;

export const StyledListboxList = forwardRef<HTMLUListElement, UlProps>(({ children, className, ...rest }, ref) => {
  return (
    <NakedUl className={cx(styledListboxListBaseStyle, className)} ref={ref} {...rest}>
      {children}
    </NakedUl>
  );
});
